/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_MeetingInputs */

const en_cc_meeting = /** @type {(inputs: Cc_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorized meeting or room`)
};

const id_cc_meeting = /** @type {(inputs: Cc_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting atau ruang yang berizin`)
};

/**
* | output |
* | --- |
* | "Authorized meeting or room" |
*
* @param {Cc_MeetingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_meeting = /** @type {((inputs?: Cc_MeetingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_MeetingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_meeting(inputs)
	return en_cc_meeting(inputs)
});